export const SEARCH_QUERY_PARAM_NAME = "searchTerm";
export const SALE_ORDER_QUERY_PARAM_CODE = "saleOrderCode";
export const PURCHASE_ORDER_QUERY_PARAM_CODE = "purchaseOrderCode";
export const EXPEDITION_QUERY_PARAM_ID = "expeditionId";
export const UNIVERSE_QUERY_PARAM_NAME = "section";
export const ASK_FOR_DETAILS_PARAM_NAME = "askfordetails";
export const PERSONAL_DATA_DAC7 = "personaldata";
export const SHOW_INFORMATION_DAC7 = "showInformation";
export const MODIFY_INFORMATION_DAC7 = "modifyInformation";
export const NICKNAME_PARAM = "nick";
export const PRODUCT_NICKNAME = "origin-route";
export const PRODUCT_NAME = "productName";
export const COUNTER_OFFER_ACTION = "action";
export const ORIGIN_PARAM_NAME = "origin";
export const LOCAL_STORAGE_NAMES = {ENTRY_ORIGIN: 'ENTRY_ORIGIN',};
export const HISTORY_KEY = 'customNavHistory';
export const URL_REDIRECT = 'redirectUrltoZara';
export const CONFIRMATION = 'confirmation';
